/**
 * appRegistry – EINZIGE Quelle aller HomePage-Sektionen/Kacheln und der
 * favorisierbaren App-Routen (Welle 38).
 *
 * item: { key, label, iconKey, modulKey, route?, navState?, action?, adminOnly? }
 *  - route      → navigierbare Seite (favorisierbar per Drag&Drop)
 *  - action     → Name eines HomePage-Handlers (Modal etc.) — NICHT favorisierbar
 *  - modulKey   → Freigabe-Key je Kachel (ma_module_freigaben); null = immer sichtbar
 *  - adminOnly  → zusätzlich rolle==='admin' nötig
 *
 * Icons werden als String-Key gespeichert (DB/Favoriten) und über ICONS
 * aufgelöst. Neues Tool = Eintrag hier + ggf. Modul-Key im Backend-Katalog
 * (backend/endpoints/benutzer/katalog.py).
 */
import {
  FaBuilding, FaCamera, FaCar, FaChartLine, FaClipboardList, FaCogs,
  FaDatabase, FaEdit, FaExchangeAlt, FaFileAlt, FaFileArchive, FaFileExcel,
  FaFileInvoiceDollar, FaHome, FaImage, FaLink, FaMapMarkerAlt,
  FaMoneyBillWave, FaFileContract, FaRobot, FaSearchPlus, FaShieldAlt,
  FaSync, FaTable, FaTachometerAlt, FaUpload, FaChartBar, FaExternalLinkAlt,
  FaInbox, FaTerminal, FaNotesMedical, FaVideo, FaTasks,
} from "react-icons/fa";

export const ICONS = {
  FaBuilding, FaCamera, FaCar, FaChartLine, FaClipboardList, FaCogs,
  FaDatabase, FaEdit, FaExchangeAlt, FaFileAlt, FaFileArchive, FaFileExcel,
  FaFileInvoiceDollar, FaHome, FaImage, FaLink, FaMapMarkerAlt,
  FaMoneyBillWave, FaFileContract, FaRobot, FaSearchPlus, FaShieldAlt,
  FaSync, FaTable, FaTachometerAlt, FaUpload, FaChartBar, FaExternalLinkAlt,
  FaInbox, FaTerminal, FaNotesMedical, FaVideo, FaTasks,
};

export function iconByKey(key) {
  return ICONS[key] || FaLink;
}

const SEKTIONEN = [
  {
    key: "umsatz",
    title: "Umsatz Import",
    headerIconKey: "FaUpload",
    headerClass: "hp-umsatz",
    sectionClass: "hp-sec-umsatz",
    items: [
      { key: "excel-export", label: "Excel Export", iconKey: "FaFileExcel", modulKey: "umsatz.excel_export", action: "createSession" },
      { key: "db-import", label: "Datenbank Import", iconKey: "FaDatabase", modulKey: "umsatz.db_import", action: "startDatabaseSession" },
      { key: "batch-csv", label: "Batch CSV → UMS", iconKey: "FaSync", modulKey: "umsatz.batch_csv", action: "excelBatch" },
      { key: "kontoanalyse", label: "Kontoanalyse", iconKey: "FaChartBar", modulKey: "umsatz.kontoanalyse", route: "/kontoanalyse" },
    ],
  },
  {
    key: "posteingang",
    title: "Posteingang",
    headerIconKey: "FaLink",
    headerClass: "hp-zuordnen",
    sectionClass: "hp-sec-zuordnen",
    items: [
      { key: "postkorb", label: "Postkorb", iconKey: "FaInbox", modulKey: "zuordnen.postkorb", route: "/postkorb" },
      { key: "krv", label: "KRV", iconKey: "FaNotesMedical", modulKey: "krv", route: "/krv" },
      { key: "verschieben", label: "Verschieben", iconKey: "FaExchangeAlt", modulKey: "zuordnen.verschieben", route: "/zuordnen/verschieben" },
      { key: "ki-regeln", label: "Gemini-Regelwerk", iconKey: "FaRobot", modulKey: "zuordnen.ki_regeln", route: "/zuordnen/ki-regeln" },
      { key: "zaehlerstaende", label: "Zählerstände", iconKey: "FaCamera", modulKey: "zaehlerstand", route: "/zuordnen/bilder", navState: { autoAnalyse: true } },
      { key: "bilder", label: "Bilder verarbeiten", iconKey: "FaMapMarkerAlt", modulKey: "zuordnen.bilder", route: "/zuordnen/fotos" },
    ],
  },
  {
    key: "mietverwaltung",
    title: "Mietverwaltung",
    headerIconKey: "FaHome",
    headerClass: "hp-miet",
    sectionClass: "hp-sec-miet",
    items: [
      { key: "zahlungen", label: "Zahlungen", iconKey: "FaMoneyBillWave", modulKey: "mietverwaltung.zahlungen", route: "/mietverwaltung?tab=zahlungen" },
      { key: "vertraege", label: "Objekte & Verträge", iconKey: "FaFileContract", modulKey: "mietverwaltung.vertraege", route: "/mietverwaltung?tab=vertraege" },
      { key: "historie", label: "Miethistorie", iconKey: "FaChartLine", modulKey: "mietverwaltung.historie", route: "/mietverwaltung?tab=historie" },
      { key: "schaeden", label: "Schäden", iconKey: "FaShieldAlt", modulKey: "mietverwaltung.schaeden", route: "/mietverwaltung?tab=schaeden" },
      { key: "bescheinigungen", label: "Dokumente", iconKey: "FaFileAlt", modulKey: "mietverwaltung.dokumente", route: "/mietverwaltung?tab=bescheinigungen" },
      { key: "vorgaenge", label: "Vorgänge (Kündigungen)", iconKey: "FaTasks", modulKey: "mietverwaltung.vorgaenge", route: "/mietverwaltung?tab=vorgaenge" },
    ],
  },
  {
    key: "rename",
    title: "Rename Me",
    headerIconKey: "FaEdit",
    headerClass: "hp-rename",
    sectionClass: "hp-sec-rename",
    items: [
      { key: "rename-einzel", label: "Einzeldatei umbenennen", iconKey: "FaFileAlt", modulKey: "rename.einzel", route: "/rename" },
      { key: "rename-engine", label: "Rename-Engine 2.0", iconKey: "FaFileAlt", modulKey: "rename.engine", route: "/rename-engine" },
      { key: "rename-review", label: "Review", iconKey: "FaClipboardList", modulKey: "rename.review", action: "review" },
      { key: "rename-batch", label: "Batch starten", iconKey: "FaSync", modulKey: "rename.batch", action: "batch" },
    ],
  },
  {
    key: "tools",
    title: "Tools",
    headerIconKey: "FaSearchPlus",
    headerClass: "hp-analysen",
    sectionClass: "hp-sec-analysen",
    items: [
      // Firmen & Objekte öffnet den Ordner-Picker (Verschieben-Ansicht) —
      // war kurzzeitig raus, gehört wieder rein.
      { key: "firmen-objekte", label: "Firmen & Objekte", iconKey: "FaBuilding", modulKey: "zuordnen.firmen_objekte", action: "dataPathPicker" },
      // „Programme starten" sass in einer eigenen Sektion, die für eine
      // einzige Kachel zu viel Platz brauchte — steht jetzt hier vorn.
      { key: "skripte", label: "Programme starten", iconKey: "FaTerminal", modulKey: "skripte", route: "/skripte" },
      { key: "rekorder", label: "Web-Rekorder", iconKey: "FaVideo", modulKey: "rekorder", route: "/rekorder" },
      { key: "komprimieren", label: "Datei komprimieren", iconKey: "FaFileArchive", modulKey: "tools.komprimieren", route: "/tools/komprimieren" },
      { key: "vb-vergleich", label: "PDF Vergleich", iconKey: "FaExchangeAlt", modulKey: "vb_vergleich", route: "/tools/vb-vergleich" },
      { key: "protokolle", label: "Protokolle", iconKey: "FaFileAlt", modulKey: "protokolle", route: "/tools/protokolle" },
      { key: "zaehler-komprimieren", label: "Zähler komprimieren", iconKey: "FaTachometerAlt", modulKey: "tools.zaehler_komprimieren", route: "/zuordnen/komprimierung" },
      { key: "bilder-komprimieren", label: "Bilder komprimieren", iconKey: "FaImage", modulKey: "tools.bilder_komprimieren", route: "/zuordnen/bilder-komprimierung" },
    ],
  },
  {
    key: "steuer",
    title: "Steuer & Rechnungen",
    headerIconKey: "FaFileInvoiceDollar",
    headerClass: "hp-steuer",
    sectionClass: "hp-sec-steuer",
    items: [
      { key: "rechnungen", label: "Rechnungen", iconKey: "FaFileInvoiceDollar", modulKey: "rechnungen", route: "/rechnungen" },
      { key: "datev", label: "DATEV-Versand", iconKey: "FaExchangeAlt", modulKey: "datev", route: "/datev" },
      { key: "fahrtenbuch", label: "Fahrtenbuch", iconKey: "FaCar", modulKey: "fahrtenbuch", route: "/fahrtenbuch" },
      { key: "arbeitsnachweis", label: "Arbeitsnachweis", iconKey: "FaClipboardList", modulKey: "arbeitsnachweis", route: "/arbeitsnachweis" },
    ],
  },
];

// Welle 101: Freigabe je Kachel — eine Sektion ist sichtbar, sobald eine ihrer Kacheln
// freigegeben ist. Keys stehen im Backend-Katalog (endpoints/benutzer/katalog.py).
export const APP_SECTIONS = SEKTIONEN.map((s) => ({
  ...s,
  modulKeys: [...new Set(s.items.map((i) => i.modulKey).filter(Boolean))],
}));

// Seiten ohne HomePage-Kachel (Navbar-Routen) — favorisierbar
export const EXTRA_ROUTES = [
  { key: "datenansicht", label: "Datenansicht", iconKey: "FaTable", modulKey: "datenbank.datenansicht", route: "/data" },
  { key: "db-tabellen", label: "DB-Tabellen", iconKey: "FaDatabase", modulKey: "datenbank.db_tabellen", route: "/database-tables" },
  { key: "db-tabellen-2", label: "DB-Tabellen 2", iconKey: "FaDatabase", modulKey: "datenbank2", route: "/database-tables-2" },
  { key: "strg", label: "STRG-Tabelle", iconKey: "FaTable", modulKey: "datenbank.strg", route: "/strg" },
  { key: "monitoring", label: "Monitoring", iconKey: "FaChartBar", modulKey: "monitoring", route: "/monitoring" },
  { key: "ki-lernen", label: "KI Lernen", iconKey: "FaRobot", modulKey: "ki.lernen", route: "/ki-lernen" },
  { key: "ki-admin", label: "KI Admin", iconKey: "FaRobot", modulKey: "ki.admin", route: "/ki-admin" },
  { key: "verwaltung", label: "Verwaltung", iconKey: "FaCogs", modulKey: null, route: "/verwaltung", adminOnly: true },
];

export const istFavorisierbar = (item) => !!item.route;
